import React from 'react';
import './AlertMessage.css';

interface Props {
  type: 'success' | 'error' | 'info';
  message: string;
}

export default function AlertMessage({ type, message }: Props) {
  if (!message) return null;
  return <div className={`alert alert--${type}`}>{message}</div>;
}
